export const styles = {
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingLeft: '32px',
    paddingRight: '32px',
    paddingTop: '32px',
    width: '100%',
    backgroundColor: '#F9F9FF',
    minHeight: '100vh',
    '@media (max-width: 768px)': {
      marginTop: '40px',
      maxWidth: '100%',
    },
  },
  loadingContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '256px',
  },
  loadingText: {
    fontSize: '18px',
    color: '#475569',
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingLeft: '32px',
    paddingRight: '32px',
    paddingTop: '32px',
    width: '100%',
    backgroundColor: '#F9F9FF',
    minHeight: '100vh',
    '@media (max-width: 768px)': {
      marginTop: '40px',
      maxWidth: '100%',
    },
  },
  header: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    alignItems: 'center',
    marginTop: '16px',
    '@media (max-width: 768px)': {
      maxWidth: '100%',
    },
  },
  backButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    padding: '8px',
    margin: 'auto 0',
    width: '36px',
  },
  backIconContainer: {
    display: 'flex',
    gap: '6px',
    justifyContent: 'center',
    alignItems: 'center',
    width: '20px',
  },
  backIcon: {
    objectFit: 'contain',
    alignSelf: 'stretch',
    margin: 'auto 0',
    width: '20px',
    aspectRatio: '1',
    cursor: 'pointer',
  },
  backText: {
    width: '570px',
    display: 'flex',
    color: '#64748B',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '1.2',
  },
  title: {
    width: '570px',
    display: 'flex',
    color: '#0F172A',
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '1',
    margin: '20px 0 0 0',
  },
  contentContainer: {
    alignSelf: 'stretch',
    marginTop: '24px',
    height: '100vh',
    '@media (max-width: 768px)': {
      maxWidth: '100%',
    },
  },
  iframe: {
    width: '700px',
    height: '750px',
    border: 'none',
  },
  saveButton: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignSelf: 'flex-end',
    padding: '12px 16px',
    marginTop: '44px',
    width: '208px',
    maxWidth: '100%',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '1',
    textAlign: 'center',
    color: '#ffffff',
    whiteSpace: 'nowrap',
    borderRadius: '12px',
    minHeight: '40px',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.2s, color 0.2s',
    '@media (max-width: 768px)': {
      marginTop: '40px',
      marginRight: '6px',
    },
  },
  saveButtonEnabled: {
    backgroundColor: '#F43F5E',
    '&:hover': {
      backgroundColor: '#DC2626',
    },
  },
  saveButtonDisabled: {
    backgroundColor: '#9CA3AF',
    cursor: 'not-allowed',
  },
}
